import { Coins, Gift, Repeat, ShoppingBag } from "lucide-react";
import type { ReactNode } from "react";

import { buildDashboardSalesTiles } from "../monetization/monetizationModel";
import { StatTile } from "./DashboardPrimitives";
import { useContactPaywallSales } from "./useExecutiveDashboard";

const MONETIZATION_HREF = "/monetization?view=summary";
const TILE_ICONS: Record<string, ReactNode> = {
  "Paid orders": <ShoppingBag className="size-4" />,
  "Net revenue": <Coins className="size-4" />,
  "Referral credits earned": <Gift className="size-4" />,
  "Repeat purchase rate": <Repeat className="size-4" />,
};

/**
 * Sales at a glance on the home page: paid orders, net revenue, referral
 * credits and repeat purchases since the contact paywall launched, each tile
 * opening the Monetization tab. Renders nothing without the dashboard API.
 */
export const SalesTiles = () => {
  const sales = useContactPaywallSales();
  if (!sales.available) return null;
  const tiles = sales.metrics ? buildDashboardSalesTiles(sales.metrics) : [];
  const labels = tiles.length
    ? tiles.map((tile) => tile.label)
    : Object.keys(TILE_ICONS);

  return (
    <section aria-labelledby="dashboard-sales-heading" className="space-y-2">
      <div className="flex flex-wrap items-baseline justify-between gap-2">
        <h2
          id="dashboard-sales-heading"
          className="text-sm font-semibold uppercase tracking-wide text-muted-foreground"
        >
          Sales
        </h2>
        <p className="text-xs text-muted-foreground">
          Contact paywall · all time · durable Stripe events
        </p>
      </div>
      <div className="grid gap-3 sm:grid-cols-2 xl:grid-cols-4">
        {labels.map((label) => {
          const tile = tiles.find((item) => item.label === label);
          return (
            <StatTile
              key={label}
              label={label}
              icon={TILE_ICONS[label]}
              to={MONETIZATION_HREF}
              isPending={sales.isPending}
              error={sales.error}
              value={tile?.value ?? "—"}
              sublabel={tile?.hint}
            />
          );
        })}
      </div>
    </section>
  );
};
